<div ngClass.gt-sm="app-container-desktop"
  ngClass.lt-md="app-container-mobile"
  fxLayout="column"
  fxFill>
  <zui-sidenav [sidenavParams]="sidenavParams"
    [header]="sidenavHeader"
    (emitSelectedCompany)="setCurrentCompanyByFormSelection($event)">
    <div *ngIf="auth.isAuthenticated$ | async"
      class="sidenav-content-container app-bg-color"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="3rem">
      <div fxLayout="column" fxLayoutAlign="start stretch" class="page-body">
        <zui-sidenav-header class="header-bar-sidenav"
          (menuToggled)="onSideNavMobileMenuButtonToggled($event)"></zui-sidenav-header>
        <div class="content-container" fxLayout="row">
          <div class="left">
            <router-outlet></router-outlet>
          </div>
          <div class="right">
            <app-map-wrapper></app-map-wrapper>
          </div>
        </div>
        <!-- No footer is necessary. We removed the footer from Maps and we can retain that general layout -->
        <!-- <zui-footer-component></zui-footer-component> -->
      </div>
    </div>
  </zui-sidenav>
</div>
